import InfiniteScroll from "react-infinite-scroll-component";
import styled from "styled-components";

export const MainContainer = styled.div`
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  background: #f6f6f9;
  min-height: 100dvh;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100dvh - 247px);
  margin-top: 140px;

  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "4rem 30rem 8rem 4rem"
          : "4rem 4rem 8rem 30rem"
        : !props.$ar
        ? "4rem 4rem 8rem 10rem"
        : "4rem 10rem 8rem 4rem"
      : "4rem 4rem"};

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem 2rem 8rem 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  justify-content: center;
`;
export const Layout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 75px;
  justify-content: center;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "8rem 30rem 8rem 4rem"
          : "8rem 4rem 8rem 30rem"
        : !props.$ar
        ? "8rem 4rem 8rem 10rem"
        : "8rem 10rem 8rem 4rem"
      : "8rem 4rem"};

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 870px) {
    padding: 8rem 0px;
  }
`;
export const Column = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  width: ${(props) => (props.$loggedIn ? "1440px" : "100%")};

  transition: all 0.3s ease-in-out;
  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "8rem 30rem 8rem 4rem"
          : "8rem 4rem 8rem 30rem"
        : !props.$ar
        ? "8rem 4rem 8rem 10rem"
        : "8rem 10rem 8rem 4rem"
      : "8rem 4rem"};

  margin-top: ${(props) => (props.$upgradePackage ? "60px" : "0px")};

  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 870px) {
    margin-top: ${(props) => (props.$upgradePackage ? "40px" : "0px")};

    padding: ${(props) =>
      props.$loggedIn ? "80px 40px 40px 40px" : "80px 40px 40px 40px"};
  }
`;

export const BackContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 25%;
`;
export const Icons = styled.div`
  display: flex;
  position: absolute;
  z-index: 50;
  cursor: pointer;
  justify-content: center;
  padding: 5px;
  flex-direction: row;
  align-items: center;
  right: 2px;
  top: 2px;
  gap: 6px;
`;
export const SectionTitle = styled.h1`
  color: #484888;
  font-family: "Avenir";
  display: flex;
  align-self: flex-start;
  margin-top: 40px;
  /* margin-left: ${(props) => (props.$loggedIn ? "45px" : "0px")}; */
  font-size: 35px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.178px;
  text-transform: capitalize;
`;
export const ClickContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  top: 4rem;
  border-radius: 2rem;
  cursor: pointer;
`;
export const ImageContainer = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: -10px;
`;

export const NothingToShowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0rem;

  gap: 1rem;
  height: 7rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  justify-content: center;
  margin: 2rem 0rem;

  gap: 1rem;

  height: 7rem;
  width: 100%;

  &&::-webkit-scrollbar {
    height: 3.8px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #48488858;
    border-radius: 10px;
  }

  &&::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;
export const SortContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  margin: 2rem 0rem;

  gap: 1rem;

  height: 7rem;
  width: 100%;

  &&::-webkit-scrollbar {
    height: 3.8px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #48488858;
    border-radius: 10px;
  }

  &&::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;

export const SortName = styled.span`
  color: ${(props) => (props.selected ? "#fff" : "rgba(255, 250, 250, 0.85)")};
  background-color: #484888;
  user-select: none;
  text-align: center;
  font-family: "Avenir-Medium";
  font-size: 1.5rem;
  letter-spacing: 0.067px;
  white-space: nowrap;
  display: flex;
  cursor: pointer;
  text-decoration: ${(props) => (props.selected ? "underline" : "none")};
  padding: 1rem 1.8rem;
  border-radius: 1rem;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #48488898;
    color: #fff;
  }
`;
export const CardProduct = styled.div`
  border-radius: 2rem;
  position: relative;
  background: #fff;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%; /* Fleksibilna širina unutar grida */
  max-width: 300px; /* Maksimalna širina kartice */
  aspect-ratio: 300 / 354; /* Postavlja proporcije širine i visine */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease-in-out;
  z-index: 10;
  background-image: url(${(props) => props.$imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  &:hover {
    z-index: 50;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
      rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    transform: scale(0.95); /* Povećava i širinu i visinu */
  }

  @media (max-width: 335px) {
    width: 90%; /* Fleksibilna širina za vrlo male ekrane */
    aspect-ratio: auto; /* Osigurava da se proporcije prilagode */
  }
`;

export const CardProductName = styled.span`
  color: #000;
  font-family: "Avenir";
  font-size: 14px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0.067px;
`;
export const ProductInfo = styled.div`
  padding: 15px 20px;
  z-index: 20;
  cursor: pointer;
  border-radius: 1rem 1rem 2rem 2rem;
  background: #fff;
  gap: 6px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 73px;
  box-shadow: 0px -5px 4px 0px rgba(0, 0, 0, 0.05);
  /* position: absolute; */
  margin-top: auto;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const Price = styled.span`
  color: rgba(0, 0, 0, 0.5);
  font-family: "Avenir";
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.067px;
`;

export const StyledInfinityScroll = styled(InfiniteScroll)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 4rem;
  padding-bottom: 10rem;
  width: 100%;

  > * {
    flex: 1 1 calc(25% - 20px); /* Održava 4 kolone */
    max-width: calc(25% - 20px); /* Sprečava prekoračenje */
    transition: all 0.3s ease-in-out;
  }

  /* Kada ima samo jedan proizvod */
  > *:only-child {
    flex: 1 1 70%;
    max-width: 350px;
    min-width: 350px;
  }

  @media (max-width: 2800px) {
    > * {
      flex: 1 1 calc(25% - 120px); /* 3 kolone za manje ekrane */
      max-width: calc(25% - 120px);
    }

    > *:only-child {
      flex: 1 1 70%;
      max-width: 400px;
      min-width: 400px;
    }
  }

  @media (max-width: 2500px) {
    > * {
      flex: 1 1 calc(25% - 20px); /* 3 kolone za manje ekrane */
      max-width: calc(25% - 20px);
    }

    > *:only-child {
      flex: 1 1 70%;
      max-width: 350px;
      min-width: 350px;
    }
  }

  @media (max-width: 1716px) {
    > * {
      flex: 1 1 calc(33.33% - 20px); /* 3 kolone za manje ekrane */
      max-width: calc(33.33% - 20px);
    }

    > *:only-child {
      flex: 1 1 80%; /* Proširuje karticu na srednjim ekranima */
      max-width: 300px;
      min-width: 300px;
    }
  }

  @media (max-width: 1185px) {
    > * {
      flex: 1 1 calc(50% - 20px); /* 2 kolone za još manje ekrane */
      max-width: calc(50% - 20px);
    }

    > *:only-child {
      flex: 1 1 80%;
      max-width: 250px;
      min-width: 250px;
    }
  }

  @media (max-width: 580px) {
    > * {
      flex: 1 1 100%; /* 1 kolona za najmanje ekrane */
      max-width: 100%;
    }

    > *:only-child {
      flex: 1 1 90%;
      max-width: 200px;
      min-width: 200px;
    }
  }

  @media (max-width: 340px) {
    > * {
      flex: unset; /* 1 kolona za najmanje ekrane */
      max-width: 100%;
      width: 30rem;
      height: 35rem;
    }
    > *:only-child {
      flex: 1 1 90%;
      max-width: 200px;
      min-width: 200px;
    }
  }
`;

export const Text = styled.span`
  color: #484888;
  user-select: none;
  font-family: "Avenir-Medium";
  font-size: 2rem;

  letter-spacing: 0.067px;
  text-align: center;
  margin-top: 8rem;
`;

export const Subtitle = styled.span`
  color: #484888;
  font-family: "Avenir-Medium";
  font-size: 2.5rem;
  line-height: 3.2rem;
  text-align: center;
  margin-top: 80px;

  @media (max-width: 645px) {
    font-size: 2rem;
    text-align: center;
  }
`;

export const StyledMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 1200px) {
    top: ${(props) => (props.$upgradePackage ? "120px" : "68px")};
  }
`;

export const GiftBoxImage = styled.img`
  user-select: none;
  background-color: transparent;
  height: 550px;
  border-radius: 21px;
  width: 100%;
  max-width: 1440px;
  object-fit: cover;

  @media (max-width: 870px) {
    height: auto;
    min-height: 32rem;
  }
`;

export const LoaderContainer = styled.div`
  padding: 5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
